import type { Language } from './i18n.ts';

/** Shared by static HTML generation and the language switcher. */
export const seoCopy = {
  en: {
    title: '2048 Ball – Free Online Merge Game | 2048 Merge',
    description: 'Play a free 2048 ball merge game online. Aim, shoot and combine bouncing jelly, crystal or fruit balls. No download or signup. Play on mobile and desktop.',
    heading: '2048 Ball Merge',
    headingWord: 'Ball Merge',
    subtitle: 'Free online ball merge game · No download',
  },
  zh: {
    title: '2048合成球在线玩｜免费弹射合成小游戏',
    description: '免费在线玩2048合成球。瞄准、蓄力、发射，让相同数字的弹球碰撞合成，挑战2048与更高分。可选果冻、宝石和水果主题，手机电脑打开即玩，无需下载或注册。',
    heading: '2048合成球',
    headingWord: '合成球',
    subtitle: '免费在线弹射合成小游戏 · 无需下载',
  },
} satisfies Record<Language, Record<string, string>>;

export function languagePath(language: Language, basePath = '/'): string {
  const base = basePath.endsWith('/') ? basePath : basePath + '/';
  return base + (language === 'zh' ? 'zh/' : '');
}

/** The existing root keeps browser/manual language selection; /zh/ is explicit. */
export function routeLanguage(pathname: string, basePath = '/'): Language | null {
  const chinese = languagePath('zh', basePath);
  return [chinese, chinese.slice(0, -1), chinese + 'index.html'].includes(pathname) ? 'zh' : null;
}

/** Keep invitation/game parameters while replacing the legacy language parameter. */
export function localizedUrl(href: string, language: Language, basePath = '/'): URL {
  const url = new URL(href);
  url.pathname = languagePath(language, basePath);
  url.searchParams.delete('lang');
  return url;
}

export function canonicalUrl(site: string, language: Language): string {
  const url = new URL(site);
  url.pathname = languagePath(language, url.pathname);
  url.search = ''; url.hash = '';
  return url.href;
}
